import React from "react";
import { Wrapper, FilterLabel, FilterButton } from "../common/Filter";
import styled from "styled-components";
import { TabList, Tab } from "@reach/tabs";
import Content from "../common/Content";
import { media } from "../theme";

interface Props {
  label: string;
  options: string[];
  activeIndex: number;
}

const FlexTabList = styled(TabList)`
  display: flex;
  width: 100%;
  @media screen and ${media.mobile} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
export default function Filter({
  label,
  options,
  activeIndex,
  ...props
}: Props) {
  const optionsLength = options.length;
  return (
    <Content padded>
      <Wrapper>
        <FilterLabel>{label}</FilterLabel>
        <FlexTabList role="tablist" {...props}>
          {options.map((o, idx) => (
            <FilterButton
              as={Tab}
              isActive={idx === activeIndex}
              key={idx}
              aria-setsize={optionsLength}
              aria-posinset={idx + 1}
              aria-label={`Sie sind ${o}`}
            >
              {o}
            </FilterButton>
          ))}
        </FlexTabList>
      </Wrapper>
    </Content>
  );
}
